import React from 'react';
import { Button, ButtonProps } from 'antd';
import { useLocation } from 'react-router-dom';
import { useNavigation } from '@App/settings/NavigationProvider';
import { EditOutlined } from '@ant-design/icons';
import { OmitProps } from 'antd/es/transfer/ListBody';

interface EditButtonProps {
  record: any;
  text?: string;
  iconOnly?: boolean;
  goTo?: string;
}

const EditButton: React.FC<EditButtonProps & ButtonProps> = ({
  text,
  record,
  iconOnly = false,
  goTo,
  ...rest
}) => {
  const { handleNavigate: nav } = useNavigation();
  const location = useLocation();

  const handleClick = () => {
    nav(goTo ?? `${location.pathname}/${record.uuid ?? record.id}`);
  };

  return (
    <Button
      type="primary"
      icon={<EditOutlined />}
      onClick={handleClick}
      {...rest}
    >
      { iconOnly && ( text ?? 'Edit')}
    </Button>
  );
};

export default EditButton;